import { render, staticRenderFns } from "./PaymentBaseForm.vue?vue&type=template&id=c0bf3ca0&scoped=true&"
import script from "./PaymentBaseForm.vue?vue&type=script&lang=ts&"
export * from "./PaymentBaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentBaseForm.vue?vue&type=style&index=0&id=c0bf3ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bf3ca0",
  null
  
)

export default component.exports